module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-content"
  }, [_c('h5', [_vm._v("Vehicle Make")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterModel.brandId),
      expression: "filterModel.brandId"
    }],
    attrs: {
      "disabled": !_vm.brands.length || !_vm.isLoaded
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterModel, "brandId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.onBrandChange()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Makes")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand.id,
      domProps: {
        "value": brand.id
      }
    }, [_vm._v(_vm._s(brand.name))])
  })], 2), _vm._v(" "), _c('h5', [_vm._v("Vehicle Model")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterModel.modelId),
      expression: "filterModel.modelId"
    }],
    attrs: {
      "disabled": !_vm.models.length || !_vm.isLoaded
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterModel, "modelId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.onModelChange()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Models")]), _vm._v(" "), _vm._l((_vm.models), function(model) {
    return _c('option', {
      key: model.id,
      domProps: {
        "value": model.id
      }
    }, [_vm._v(_vm._s(model.name))])
  })], 2), _vm._v(" "), _c('h5', [_vm._v("Vehicle Trim")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterModel.trim),
      expression: "filterModel.trim"
    }],
    attrs: {
      "disabled": !_vm.trims.length || !_vm.isLoaded
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterModel, "trim", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.onTrimChange()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Trims")]), _vm._v(" "), _vm._l((_vm.trims), function(trim, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": trim
      }
    }, [_vm._v(_vm._s(trim))])
  })], 2), _vm._v(" "), _c('h5', [_vm._v("Vehicle Year")]), _vm._v(" "), _c('range-slider', {
    staticClass: "filter-slider",
    attrs: {
      "id": 'years-range',
      "minRange": _vm.yearRange.from,
      "maxRange": _vm.yearRange.to,
      "minValue": _vm.years.from,
      "maxValue": _vm.years.to,
      "limit": _vm.years.from !== _vm.years.to ? _vm.yearLimit : null,
      "step": _vm.yearStep,
      "disabled": !_vm.isLoaded
    },
    on: {
      "change": _vm.onYearsChanged
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Vehicle Price")]), _vm._v(" "), _c('range-slider', {
    staticClass: "filter-slider",
    attrs: {
      "id": 'price-range',
      "minRange": _vm.priceRange.from,
      "maxRange": _vm.priceRange.to,
      "minValue": _vm.price.from,
      "maxValue": _vm.price.to,
      "allowSameValues": false,
      "limit": _vm.priceLimit,
      "step": _vm.priceStep,
      "disabled": !_vm.isLoaded
    },
    on: {
      "change": _vm.onPriceChanged
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Vehicle Body")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterModel.body),
      expression: "filterModel.body"
    }],
    attrs: {
      "disabled": !_vm.bodies.length || !_vm.isLoaded
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterModel, "body", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.onBodyChange()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Bodies")]), _vm._v(" "), _vm._l((_vm.bodies), function(body, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": body
      }
    }, [_vm._v(_vm._s(body))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoaded),
      expression: "!isLoaded"
    }],
    staticClass: "loader"
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    on: {
      "click": function($event) {
        return _vm.resetAndSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/black/menu_close.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("RESET SEARCH")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_c('span', [_vm._v("SHOW RESULT")])])]), _vm._v(" "), (!_vm.isLoaded) ? _c('div', {
    staticClass: "loader-container",
    attrs: {
      "color": "#f9f300"
    }
  }, [_c('loader', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": "#f9f300"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-264c7e10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-264c7e10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/inventory/vauto-filter.vue
// module id = 751
// module chunks = 0